import { Component, OnInit } from '@angular/core';

import { ReportService } from '../report.service';
import { Utils } from '../../common/services/utils.service';
import { HttpRequestService } from '../../common/services/http-request.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';


@Component({
  selector: 'app-plan-modal',
  templateUrl: './plan-modal.component.html',
  styleUrls: ['./plan-modal.component.css'],
  // providers: [ DynamicDialogConfig, DynamicDialogRef, DialogService]
})
export class PlanModalComponent implements OnInit {

  reqtableDatasource: any[];
  reqtableConfigs: object;
  reqtableColumnConfigs: any[];
  gridCallBacks: object = {};

  constructor(public config: DynamicDialogConfig,
    private utils: Utils,
    private httpService: HttpRequestService,
    public ref: DynamicDialogRef,
    private reportService: ReportService) { }

  fetchRequestDetails(selectedList) {
    const requestData = this.utils.constructRequestData(selectedList.requestData, 'CoreRequestService', selectedList.methodName);

    this.httpService.configRequestDataWithHeaders(requestData, 'post', '')
      .subscribe((response: any) => {
        let gridSource;
        this.reqtableConfigs = this.reportService.getReportTableConfigs();
        this.reqtableConfigs['showAdvanceFilter'] = false;
        if (selectedList.target === 'REQUEST_NUMBER') {
          gridSource = this.utils.findAndSetGridSource(response['grid_array'], 'RequestStatusView');
          this.reqtableColumnConfigs = this.reportService.getReqTableColumnConfigs();
          this.reqtableConfigs['gridId'] = 'reqModalTable';
        } else if (selectedList.selectedItem.TYPE === 'Material') {
          gridSource = this.utils.findAndSetGridSource(response['grid_array'], 'Materialpopupview');
          this.reqtableColumnConfigs = this.reportService.getTripMatTableColumnConfigs();
          this.reqtableConfigs['gridId'] = 'tripMatModalTable';
        } else {
          gridSource = this.utils.findAndSetGridSource(response['grid_array'], 'Passengerpopupview');
          this.reqtableColumnConfigs = this.reportService.getTripPaxTableColumnConfigs();
          this.reqtableConfigs['gridId'] = 'tripPaxModalTable';
        }
        this.utils.insertIdFieldInDataSource(gridSource);
        this.reqtableDatasource = gridSource;
      });
  }

  onClose() {
    this.ref.close();
  }

  ngOnInit() {
    this.fetchRequestDetails(this.config.data);
  }

}
